import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import VueSlider from 'vue-slider-component';
import numberService from '@/services/number.service';
import ServerContextService from '@/core/server-context.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryProductFacetFilteringByPrice',
  props: {
    min: null,
    max: null,
    ranges: null
  },
  emits: ["range"],
  setup(__props: any, { expose, emit }: { emit: ({(e: 'range', values: number[]): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    min?: number | null,
    max?: number | null,
    ranges: number[]
}





const rangeValues = computed(() => props.ranges);

const sortedRange = rangeValues.value.sort((a, b) => a - b);

const roundedRange = computed(() => {
    const d = {
        min: Math.floor(sortedRange[0] / 1000) * 1000,
        max: Math.ceil(sortedRange[sortedRange.length - 1] / 1000) * 1000
    };
    return d;
});

const value = ref<number[]>(props.min !== undefined && props.max !== undefined ? [props.min, props.max] : [roundedRange.value.min, roundedRange.value.max]);
const slider = ref<VueSlider | null>(null);
const internalValue = ref<number[]>([]);
const interval = ref(1000);

const { languageName, currencyName } = ServerContextService;

expose({ resetRanges });

function resetRanges() {
    value.value = [roundedRange.value.min, roundedRange.value.max];
};

const range = computed<{from: string, to:string}>({
    get() {
        return {
            from: numberService.formatCurrency(value.value[0], true, true, languageName, currencyName),
            to: numberService.formatCurrency(value.value[1], true, false, languageName, currencyName)
        };
    },
    set() {
        return {
            from: numberService.formatCurrency(roundedRange.value.min, true, true, languageName, currencyName),
            to: numberService.formatCurrency(roundedRange.value.max, true, false, languageName, currencyName)
        };
    }
});

const setRange = () => {
    emit('range', [internalValue.value[0], internalValue.value[1]]);
};

function setRanged(e:PointerEvent) {
    const target = e.target as HTMLDivElement;
    if (!target.classList.contains('vue-slider-dot-handle')) {
        setRange();
    }
}

const changed = (e) => {
    if (internalValue.value[1] - internalValue.value[0] < 5000) {
        interval.value = 100;
    } else {
        interval.value = 1000;
    }
    internalValue.value = e;
};

const options = {
    dotSize: 44,
    height: 4,
    tooltip: 'none',
    tooltipPlacement: 'bottom',
    tooltipStyle: { backgroundColor: '#000' }
};

return { __sfc: true,props, emit, rangeValues, sortedRange, roundedRange, value, slider, internalValue, interval, languageName, currencyName, resetRanges, range, setRange, setRanged, changed, options, VueSlider }
}

})